// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__VVY7T","inputDescription":"styles_inputDescription__1zGtx"};